import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=cbd7302a&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbd7302a')) {
      api.createRecord('cbd7302a', component.options)
    } else {
      api.reload('cbd7302a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=cbd7302a&", function () {
      api.rerender('cbd7302a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/functionality/Index.vue"
export default component.exports